// BUILD-046 section D (Owner direction of 2026-10-21): sorting by ORDERED RULES (for example Priority, then Task due date) by composing the existing column orders of taskOrdering.ts.
//
// taskOrdering.sortTasks is a stable sort (ties keep the order they came in), so applying the rules from the LAST to the FIRST gives the order of the first rule with the second
// breaking its ties, and so on. No comparison is written here and no protected sort is touched: every rule is the same Task, Assigned to, Priority, Task due date or Status order a
// column heading already uses (unset and unknown values last in both directions). Rules cover the LOADED rows only, like every other sort.
//
// Pure module. Erasable TypeScript only.
import { sortTasks } from "./taskOrdering";
import type { OrderableTask, OrderKey } from "./taskOrdering";

const TASK_KEYS: readonly string[] = ["title", "assignee", "priority", "due", "status"];
import type { SortRule } from "./presetsModel";

/** The rows in the order of the rules; a new array. No rules: the rows as they came. */
export function applySortRules<T extends OrderableTask>(rows: readonly T[], rules: readonly SortRule[]): T[] {
  // Only the keys of the task tables; a key of the Assigned by Me table (issuedOrdering.ts orders those) is not a task order and is skipped.
  const usable = rules.filter((rule): rule is SortRule & { key: OrderKey } => TASK_KEYS.includes(rule.key));
  let out: T[] = [...rows];
  for (let index = usable.length - 1; index >= 0; index--) out = sortTasks(out, usable[index].key, usable[index].direction);
  return out;
}
